(function () {
  if (window.__renkKutucuklari) return;
  window.__renkKutucuklari = true;

  function kartGorseli(el) {
    var kart = el.closest('.card-wrapper, .bbs-card, .product-grid-item');
    return kart ? kart.querySelector('.card__media img, .bbs-img-primary, .main-img') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var kutu = e.target.closest && e.target.closest('.renk-kutu[data-img]');
    if (!kutu) return;
    var img = kartGorseli(kutu);
    if (!img) return;
    if (!img.dataset.renkOrijinal) {
      img.dataset.renkOrijinal = img.src;
      img.dataset.renkOrijinalSrcset = img.getAttribute('srcset') || '';
    }
    if (kutu.dataset.srcset) img.setAttribute('srcset', kutu.dataset.srcset); else img.removeAttribute('srcset');
    img.src = kutu.dataset.img;
  });

  document.addEventListener('mouseout', function (e) {
    var alan = e.target.closest && e.target.closest('.renk-kutulari');
    if (!alan || (e.relatedTarget && alan.contains(e.relatedTarget))) return;
    var img = kartGorseli(alan);
    if (!img || !img.dataset.renkOrijinal) return;
    if (img.dataset.renkOrijinalSrcset) img.setAttribute('srcset', img.dataset.renkOrijinalSrcset); else img.removeAttribute('srcset');
    img.src = img.dataset.renkOrijinal;
  });

  /* Urun sayfasi: renk seceneklerine kutucuk ekle */
  function renkKutulariKur() {
    var harita = window.renkHaritasi || {};
    document.querySelectorAll('.lfn-variant-boxes-grid .lfn-dropdown-box').forEach(function (box) {
      var etiket = box.querySelector('.lfn-box-label');
      var ad = etiket ? etiket.textContent.toLocaleLowerCase('tr') : '';
      if (ad.indexOf('renk') === -1 && ad.indexOf('color') === -1) return;
      box.querySelectorAll('.lfn-menu-item').forEach(function (item) {
        if (item.classList.contains('renk-secim')) return;
        var bg = harita[item.getAttribute('data-value')];
        if (!bg) return;
        var daire = document.createElement('span');
        daire.className = 'lfn-renk-daire';
        daire.style.setProperty('--renk', bg);
        item.insertBefore(daire, item.firstChild);
        item.classList.add('renk-secim');
        item.title = item.getAttribute('data-value');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renkKutulariKur);
  else renkKutulariKur();
})();
